<template>
  <div class="Home-Foot" v-if="homefoot">
    <!-- PC -->
    <div class="homeFootContent  hidden-sm-and-down" v-if="this.isEn != '1'">
      <div class="homeFootContentTop">
        <div class="row" style="font-size: 18px;">
          <div class="col-md-8" style="text-align:left;">服务热线：{{CompanyData.companyInfo.hotline || phoneNum}}</div>
          <div class="col-md-2">关注我们</div>
          <div class="col-md-2" style="text-align: right;"></div>
          <!-- <div class="col-md-2">关注我们</div> -->
          <!-- <div class="col-md-2" @click="OpenContact" style="cursor: pointer;text-align: right;">
            <span class="astyle">
              <span class="el-icon-chat-round" style="margin-right: 4px;font-size: 22px;"></span>
              <span style="vertical-align: text-bottom;">在线留言</span>
            </span>
          </div> -->
        </div>
      </div>
      <div class="homeFootContentCenter">
        <div class="row">
          <div class="col-md-2">
             <!-- @click="hrefTo('/product')" -->
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="goto_sceneDetail('traffic')"> 产品方案 </span> </div>
            <div class="homeFootContentCenter-list">
              <div><span class="astyle" @click="goto_sceneDetail('traffic')">交通场景</span></div>
              <div><span class="astyle" @click="goto_sceneDetail('Medical')">医疗场景</span></div>
              <div><span class="astyle" @click="goto_sceneDetail('socialSecurity')">社保场景</span></div>
              <div><span class="astyle" @click="goto_sceneDetail('Supermarket')">商超场景</span></div>
              <div><span class="astyle" @click="goto_sceneDetail('more')">更多场景</span></div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="hrefTo('/service')"> 服务支持 </span> </div>
            <div class="homeFootContentCenter-list">
              <div><span class="astyle" @click="hrefToP('service','miao1')">售后服务</span></div>
              <div><span class="astyle" @click="hrefToP('service','miao2')">常见问题</span></div>
             <!-- <div><span class="astyle" @click="hrefToP('developmenter','')">下载中心</span></div>-->
              <div><span class="astyle" @click="hrefToP('service','miao4')">联系我们</span></div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="hrefTo('/news')"> 新闻动态 </span> </div>
            <div class="homeFootContentCenter-list">
              <div><span class="astyle" @click="hrefTo('/news')">公司新闻</span></div>
              <div><span class="astyle" @click="hrefTo('/news')">行业动态</span></div>
              <!-- <div><span class="astyle" @click="hrefTo('/news')">产品视频</span></div> -->
            </div>
          </div>
          <div class="col-md-2">
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="hrefTo('/about')"> 关于我们 </span> </div>
            <div class="homeFootContentCenter-list">
              <div><span class="astyle" @click="hrefTomao({name:'about',mao:'miao1'})">企业简介</span></div>
              <div><span class="astyle" @click="hrefTomao({name:'about',mao:'miao2'})">发展历程</span></div>
              <div><span class="astyle" @click="hrefTomao({name:'about',mao:'miao3'})">企业文化</span></div>
              <!-- <div><span class="astyle" @click="hrefTomao({name:'about',mao:'miao4'})">知识产权</span></div> -->
              <div><span class="astyle" @click="hrefTomao({name:'about',mao:'miao5'})">荣誉资质</span></div>
            </div>
          </div>
          <div class="col-md-4" style="display: flex;">
            <div class="homeFootContentCenter-part">
              <div class="homeFootContentCenter-img">
                <img src="../assets/img/gongzhonghao.jpg" alt="德卡微信公众号" style="width:100%;height:100%;"  />
              </div>
              <div class="homeFootContentCenter-imgdesc">德卡微信公众号</div>
            </div>
            <div class="homeFootContentCenter-part">
              <div class="homeFootContentCenter-img">
                <img src="../assets/img/guanwang.jpg" alt="德卡官网" style="width:100%;height:100%;"  />
              </div>
              <div class="homeFootContentCenter-imgdesc">德卡官网</div>
            </div>
          </div>
        </div>
      </div>
      <div class="homeFootContentBotttom">
        <div class="row">
          <div class="col-md-8"> {{CompanyData.companyInfo.copyright || phoneNum}} </div>
          <div class="col-md-4"><span class="astyle" @click="openbeian"> {{CompanyData.companyInfo.copyrightNo}} </span></div>
        </div>
      </div>
    </div>
    <div class="homeFootContent  hidden-sm-and-down" v-if="this.isEn == '1'">
      <div class="homeFootContentTop">
        <div class="row" style="font-size: 18px;">
          <div class="col-md-8" style="text-align:left;">Service Hotline：{{CompanyData.companyInfo.hotline || phoneNum}}</div>
          <div class="col-md-2">Follow Us</div>
          <div class="col-md-2" style="text-align: right;"></div>
          <!-- <div class="col-md-2">关注我们</div> -->
          <!-- <div class="col-md-2" @click="OpenContact" style="cursor: pointer;text-align: right;">
            <span class="astyle">
              <span class="el-icon-chat-round" style="margin-right: 4px;font-size: 22px;"></span>
              <span style="vertical-align: text-bottom;">在线留言</span>
            </span>
          </div> -->
        </div>
      </div>
      <div class="homeFootContentCenter">
        <div class="row">
          <div class="col-md-2">
            <!-- @click="hrefTo('/product')" -->
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="goto_sceneDetail('traffic')"> Products and Solutions </span> </div>
            <div class="homeFootContentCenter-list">
              <div><span class="astyle" @click="goto_sceneDetail('traffic')">Traffic Scene</span></div>
              <div><span class="astyle" @click="goto_sceneDetail('Medical')">Medical Scene</span></div>
              <div><span class="astyle" @click="goto_sceneDetail('socialSecurity')">Social Security Scene</span></div>
              <div><span class="astyle" @click="goto_sceneDetail('Supermarket')">Supermarket Scene</span></div>
              <div><span class="astyle" @click="goto_sceneDetail('more')">More Scenes</span></div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="hrefTo('/service')"> Services and Supports </span> </div>
            <div class="homeFootContentCenter-list">
              <div><span class="astyle" @click="hrefToP('service','miao1')">Customer Service</span></div>
              <div><span class="astyle" @click="hrefToP('service','miao2')">Frequently Asked Question</span></div>
              <!-- <div><span class="astyle" @click="hrefToP('developmenter','')">下载中心</span></div>-->
              <div><span class="astyle" @click="hrefToP('service','miao4')">Contact Us</span></div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="hrefTo('/news')"> News and Trends </span> </div>
            <div class="homeFootContentCenter-list">
              <div><span class="astyle" @click="hrefTo('/news')">Company News</span></div>
              <div><span class="astyle" @click="hrefTo('/news')">Industry Trends</span></div>
              <!-- <div><span class="astyle" @click="hrefTo('/news')">产品视频</span></div> -->
            </div>
          </div>
          <div class="col-md-2">
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="hrefTo('/about')"> About Us </span> </div>
            <div class="homeFootContentCenter-list">
              <div><span class="astyle" @click="hrefTomao({name:'about',mao:'miao1'})">Company Profile</span></div>
              <div><span class="astyle" @click="hrefTomao({name:'about',mao:'miao2'})">History</span></div>
              <div><span class="astyle" @click="hrefTomao({name:'about',mao:'miao3'})">Corporate Culture</span></div>
              <!-- <div><span class="astyle" @click="hrefTomao({name:'about',mao:'miao4'})">知识产权</span></div> -->
              <div><span class="astyle" @click="hrefTomao({name:'about',mao:'miao5'})">Qualification and Honor</span></div>
            </div>
          </div>
          <div class="col-md-4" style="display: flex;">
            <div class="homeFootContentCenter-part">
              <div class="homeFootContentCenter-img">
                <img src="../assets/img/gongzhonghao.jpg" alt="德卡微信公众号" style="width:100%;height:100%;"  />
              </div>
              <div class="homeFootContentCenter-imgdesc">Decard WeChat Officail Account</div>
            </div>
            <div class="homeFootContentCenter-part">
              <div class="homeFootContentCenter-img">
                <img src="../assets/img/guanwang.jpg" alt="德卡官网" style="width:100%;height:100%;"  />
              </div>
              <div class="homeFootContentCenter-imgdesc">Official Website</div>
            </div>
          </div>
        </div>
      </div>
      <div class="homeFootContentBotttom">
        <div class="row">
          <div class="col-md-8"> {{CompanyData.companyInfo.copyright || phoneNum}} </div>
          <div class="col-md-4"><span class="astyle" @click="openbeian"> {{CompanyData.companyInfo.copyrightNo}} </span></div>
        </div>
      </div>
    </div>

    <!-- 移动 -->
    <div class="homeFootContent sm-homeFootContent visible-sm-and-down" v-if="this.isEn != '1'">
      <div class="homeFootContentTop">
        <div class="row">
          <div style="width: 100%;text-align: center;font-size:15px;" >服务热线</div>
          <div @click="servicePhone" class="phone-btn"><span class="el-icon-phone"></span> {{CompanyData.companyInfo.hotline || phoneNum}}</div>
        </div>
      </div>
      <div class="homeFootContentCenter">
        <div class="row">
          <div class="footer-ewm">
            <div class="homeFootContentCenter-part-move">
              <div class="homeFootContentCenter-img">
                <img src="../assets/img/gongzhonghao.jpg" style="width:100%;" alt="德卡微信公众号" />
              </div>
              <div class="homeFootContentCenter-imgdesc">德卡微信公众号</div>
            </div>
          </div>
          <div class="title-lis">
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="hrefTo('/mobileProductList/2')"> 产品方案 </span> </div>
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="hrefTo('/service')"> 服务支持 </span> </div>
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="hrefTo('/about')"> 关于我们 </span> </div>
          </div>
          <div class="title-lis">
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="hrefTo('/news')"> 新闻资讯 </span> </div>
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="hrefTo('/ServicePlatform')"> 服务平台 </span> </div>
            <div class="homeFootContentCenter-title"> <span class="astyle" style="color: transparent;"> 备用菜单</span> </div>
          </div>
        </div>
      </div>
      <div class="homeFootContentBotttom has-line">
        <div class="row">
          <div class="col-md-8"> {{CompanyData.companyInfo.copyright || phoneNum}} </div>
          <div class="col-md-4"><span class="astyle" @click="openbeian"> {{CompanyData.companyInfo.copyrightNo}} </span></div>
        </div>
      </div>
    </div>

    <div class="homeFootContent sm-homeFootContent visible-sm-and-down" v-if="this.isEn == '1'">
      <div class="homeFootContentTop">
        <div class="row">
          <div style="width: 100%;text-align: center;font-size:15px;" >Service Hotline</div>
          <div @click="servicePhone" class="phone-btn"><span class="el-icon-phone"></span> {{CompanyData.companyInfo.hotline || phoneNum}}</div>
        </div>
      </div>
      <div class="homeFootContentCenter">
        <div class="row">
          <div class="footer-ewm">
            <div class="homeFootContentCenter-part-move">
              <div class="homeFootContentCenter-img">
                <img src="../assets/img/gongzhonghao.jpg" style="width:100%;" alt="德卡微信公众号" />
              </div>
              <div class="homeFootContentCenter-imgdesc">Decard WeChat Officail Account</div>
            </div>
          </div>
          <div class="title-lis">
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="hrefTo('/mobileProductList/2')"> Products and Solutions </span> </div>
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="hrefTo('/service')"> Services and Supports </span> </div>
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="hrefTo('/about')"> About Us </span> </div>
          </div>
          <div class="title-lis">
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="hrefTo('/news')"> News and Trends </span> </div>
            <div class="homeFootContentCenter-title"> <span class="astyle" @click="hrefTo('/ServicePlatform')"> Service Platform </span> </div>
            <div class="homeFootContentCenter-title"> <span class="astyle" style="color: transparent;"> Alternate Menu</span> </div>
          </div>
        </div>
      </div>
      <div class="homeFootContentBotttom has-line">
        <div class="row">
          <div class="col-md-8"> {{CompanyData.companyInfo.copyright || phoneNum}} </div>
          <div class="col-md-4"><span class="astyle" @click="openbeian"> {{CompanyData.companyInfo.copyrightNo}} </span></div>
        </div>
      </div>
    </div>

    <contact-us ref="ContactParameter"></contact-us>
  </div>
</template>

<script>
import ContactUs from "@/components/ContactUs"
import Bus from '../Bus.js';

export default {
  name: "HomeFoot",
  components:{
        ContactUs
  },
  data() {
    return {
      msg: "",
      phoneNum:"400-888-7816",
      homefoot:true,
      CompanyData:{
        companyInfo:{
          hotline:""
        },
        companyParamList:{}
      }
    };
  },
  methods:{
    OpenContact(){
      this.$refs.ContactParameter.ContentStatus();
      // this.$emit("OpenContact");
    },
    openbeian(){
      window.open("http://beian.miit.gov.cn")
    },
    hrefTo(where){
      this.$router.push(where);
    },
    hrefToP(name,p){
      this.$router.push({
          name: name,
          params: {
            custormAnchor_nav: p
          }
      });
      if(this.$route.path=="/service"){
        Bus.$emit('change_service_miao',p);
      }
    },
    // 场景 进入
    goto_sceneDetail(scene){
      this.$router.push(`/mobileScene/${scene}`);
    },
    hrefTomao(where){
      if(this.$route.path=="/about"){
        let scroll_value =$(".router-view").scrollTop() + $("#"+where.mao).offset().top;
        $('.about-page').animate({ scrollTop:(Number(scroll_value)-150) }, 600);
      }else{
        this.$router.push({
          name: `${where.name}`,
          params: {
            mao: `${where.mao}`
          }
        });
      }
    },
    servicePhone(){
      if(this.CompanyData.companyInfo&&this.CompanyData.companyInfo.hotline){
          window.location.href = 'tel://' + this.CompanyData.companyInfo.hotline;
      }else{
          window.location.href = 'tel://' + this.phoneNum;
      }
    }
  },
  mounted(){
    axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/company/info?isEn=`+ this.isEn,).then(response => {
        var res=response.data
        if(res.code=== 200){
            this.CompanyData = res.data
        }else{
            this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
        }
    }).catch(error=>{
        this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
    })

  },
  created() {
      this.isEn = sessionStorage.getItem("isEn") == '1' ? '1' : '0'
  }
};
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Home-Foot {
  width: 100%;
  /* height: 500px; */
  background: #282828;
}
.homeFootContent {
  height: 100%;
  margin: 0 auto;
  padding: 50px 0;
  text-align: left;
  color: #8b8b8b;
}
.homeFootContentCenter {
  border-top: .3px solid #414141;
  margin-top: 50px;
  padding: 40px 0;
  text-align: left;
}
.homeFootContentCenter-title {
  font-size: 16px;
  margin-bottom: 20px;
}
.homeFootContentCenter-list div {
  font-size: 12px;
  margin-bottom: 5px;
  font-size: 14px;
}
.homeFootContentCenter-part{
  float: left;
  margin-right: 30px;
}
.homeFootContentCenter-img {
  margin: 0 auto;
  margin-bottom: 10px;
  width: 120px;
  /* height: 120px; */
}
.homeFootContentCenter-imgdesc {
  text-align: center;
  font-size: 14px;
  margin-top: 5px;
}
.homeFootContentBotttom {
  margin-top: 40px;
  text-align: left;
  font-size: 14px;color: #888888;
}
.astyle:hover{
  cursor: pointer;
  /* border-bottom: 1px solid #888; */
  color: #9b9b9b;
}



/* 移动端 */
.sm-homeFootContent{
  color: #ffffff;
}
.sm-homeFootContent .has-line{
  border-top: 1px solid #6B6B6B;
}
.homeFootContentCenter-part-move{
    text-align: center;
    margin: 6px auto;
    margin-bottom: 39px;
}
.sm-homeFootContent .phone-btn{
    margin: 0px auto;
    margin-top: 13px;
    border: 0.5px solid #7A7A7A;
    width: 85%;
    text-align: center;
    height: 45px;
    line-height: 45px;
    font-size: 14px;
}
@media only screen and (max-width:991px) {
  .homeFootContentCenter-img{
    width: 60%;
    margin-bottom: 0px;
  }
  .sm-homeFootContent .phone-btn{
    width: 100%;
}
  .homeFootContentCenter {
    border-top: .3px solid  #282828!important;
    margin-top: 20px;
    padding: 20px 0;
    text-align: left;
  }
  .sm-homeFootContent .phone-btn{
    border: .3px solid #7A7A7A;
  }
  .title-lis{
    font-size: 14px;
    display: flex;
    width: 100%;
    margin: 0 auto;
    justify-content:space-between;
  }
  .title-left{
    float:left;
  }
  .title-right{
    float:right;
  }
  .footer-ewm{
    display:flex;
    width:100%;
    padding:0 15px;
    justify-content:space-between;
  }
  .homeFootContentBotttom{
    margin-top: 5px;
    padding-top: 10px;
    font-size: 12px;
    color: #737373;
  }
  .sm-homeFootContent .has-line{
    border-top: 0.5px solid #6B6B6B;
    font-size: 12px;
    color: #737373;
  }
  .homeFootContentCenter-imgdesc{
    font-size: 14px;
  }
  .homeFootContentCenter-title{
    font-size: 14px;
  }
  .sm-homeFootContent .has-line .row div{
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomeFoot.vue